import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch.js";
import { useTranslation } from "react-i18next";
const useNavLinks = () => {
  const [navLinks, setNavLinks] = useState([]);
  const { fetchData } = useFetch();
  const { t } = useTranslation();
  const getMenu = async () => {
    const services = await fetchData(`services`);

    const links = [
      {
        name: t("nav_home"),
        path: "/",
      },
      {
        name: t("nav_about"),
        path: "about-us",
      },
      {
        name: t("nav_services"),
        mega: true,
        menu: services?.services,
      },

      {
        name: t("nav_resources"),
        path: "resources",
      },
      {
        name: t("nav_partner"),
        path: "clients",
      },

      {
        name: t("nav_projects"),
        path: "projects",
      },
      {
        name: t("nav_certificates"),
        path: "certificates",
      },
      {
        name: t("nav_contact"),
        path: "contact-us",
      },
    ];

    setNavLinks(links);
  };

  useEffect(() => {
    getMenu();
  }, []); // Depend on `ready` to ensure translations are loaded

  return navLinks;
};

export default useNavLinks;
